module.exports = __webpack_public_path__ + "static/media/IconTemplates_-98.e827690f.svg";